// is this deprecated?

import axios, { AxiosError } from "axios";
import { useRef } from "react";
import { useAcademicYearContext } from "../context/AacademicYearContext";
import { useLoading } from "../context/loading/LoadingContext";
import { EASY_EDU_SERVER_BASE_URL } from "../environment";
import { getLoggedInUserToken } from "../modules/common/user/UserService";
import { SESSION_EXPIRED_PATH } from "../auth/useSessionExpiry";
import { isIdle, refreshAccessToken } from "../auth/tokenRefresh";

// EASY_EDU_SERVER_REST_URL
export const axiosInstance = axios.create({
  baseURL: EASY_EDU_SERVER_BASE_URL || "http://localhost:8080/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

let initialized = false;

// ✅ Define loader APIs as regex patterns for static & dynamic paths
export const loadingApisRegex: RegExp[] = [
  /^\/api\/attendances$/,
  /^\/api\/students$/,
  /^\/api\/attendances\/grade\/[^/]+\/section\/[^/]+$/, // dynamic segments
  /^\/api\/feeDue\/student$/,
  // add other API endpoints here
];

export const useConfgrAxiosInterceptors = () => {
  console.log("Entering useConfgrAxiosInterceptors");

  const loading = useLoading();
  const academicYearRef = useRef<string | null>(null);

  const { currentAcademicYear } = useAcademicYearContext();

  console.log("currentAcademicYear " + currentAcademicYear);
  academicYearRef.current = currentAcademicYear;
  console.log("currentAcademicYear " + academicYearRef.current);

  if (initialized) return; // ✅ MINIMUM FIX
  initialized = true;

  console.log("currentAcademicYear after initialized: " + currentAcademicYear);
  console.log("academicYearRef.current after initialized: " + academicYearRef.current);

  const shouldShowLoader = (url?: string, method?: string) => {
    if (!url || !method) return false;

    // Always show for mutating requests
    if (["post", "put", "delete", "patch"].includes(method.toLowerCase())) return true;

    // For GET requests, only show for selected endpoints
    const path = url.replace(/^https?:\/\/[^/]+/, "");
    return loadingApisRegex.some((regex) => regex.test(path));
  };

  axiosInstance.interceptors.request.use(
    (req) => {
      const url = req.url;
      const method = req.method;

      console.log("In interceptors.request");
      // Show loader only for POST/PUT/DELETE to selected APIs
      if (shouldShowLoader(url, method)) {
        loading.show();
      }

      let hostName = window.location.hostname;
      const tenant = hostName.includes(".") ? hostName.split(".")[0] : "demo";
      req.headers.set("X-TenantID", tenant);
      req.headers.set("X-Academic-Year-Name", academicYearRef.current ?? "");

      if (!url.includes("auth") && !url.includes("public")) {
        const token = getLoggedInUserToken();
        req.headers.set("Authorization", `Bearer ${token}`);
      }
      return req;
    },
    (e: AxiosError) => {
      const url = e.response?.config?.url;
      const method = e.response?.config?.method;

      if (shouldShowLoader(url, method)) {
        loading.hide();
      }
      alert("In Req Incep, err block");
      console.log(e);
    },
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      const url = res.config.url;
      const method = res.config.method;

      if (shouldShowLoader(url, method)) {
        loading.hide();
      }
      return res;
    },
    async (e: AxiosError) => {
      const url = e.response?.config?.url;
      const method = e.response?.config?.method;

      if (shouldShowLoader(url, method)) {
        loading.hide();
      }

      let reqURL: string = e.request?.responseURL ?? "";
      if (reqURL.indexOf("auth") < 0 && e.response?.status === 401) {
        // the access token ran out (e.g. the laptop slept past the silent renewal): renew once and
        // retry, unless the user has been idle too long
        const original = e.config as (typeof e.config & { _retried?: boolean }) | undefined;
        if (original && !original._retried && !isIdle() && (await refreshAccessToken())) {
          original._retried = true;
          return axiosInstance(original); // the request interceptor adds the new token
        }
        console.log("JWT token expired");
        // the page removes the logged-in user (only those keys, not the whole localStorage)
        window.location.href = SESSION_EXPIRED_PATH;
      } else if ("ERR_NETWORK" === e.code) {
        console.log("Server down or network issue. Please contact Admin!");
      }
      //Revisit this comment.
      //If we return error its causing issue. post, get is not getting into .catch on the post or get. Understand ..
      //If we return like this, it goes to .post -> catch
      return Promise.reject(e);
    },
  );
};
